var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isBusy,
          expression: "isBusy",
        },
      ],
      ref: "form",
      attrs: {
        model: _vm.form,
        rules: _vm.rules,
        "element-loading-spinner": "el-icon-loading",
        "label-width": "250",
      },
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "Brand", prop: "brand_id" } },
        [
          _c(
            "el-select",
            {
              staticClass: "w-100",
              attrs: { placeholder: "Brand" },
              model: {
                value: _vm.form.brand_id,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "brand_id", $$v)
                },
                expression: "form.brand_id",
              },
            },
            _vm._l(_vm.brandOptions, function (option) {
              return _c("el-option", {
                key: option.value,
                attrs: { label: option.label, value: option.value },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "text-muted small mb-3" }, [
        _c("div", [
          _c("strong", [_vm._v("File format:")]),
          _vm._v(" CSV, one phone number per line, no header row."),
        ]),
        _vm._v(" "),
        _c("ul", { staticClass: "pl-3 mb-0" }, [
          _c("li", [
            _vm._v(
              "Only the first column is read, any other columns are ignored."
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Accepted: (803) 518-2700, 803-518-2700, 8035182700, +18035182700."
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("Numbers are read as US unless they start with +."),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Every line is reported in the import log: created, unchanged or invalid."
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "Import File:", prop: "file" } },
        [
          _vm.isFileSelected
            ? _c("div", [
                _c("em", [_vm._v(_vm._s(this.fileInfo))]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "btn btn-link btn-link-red px-1",
                    on: { click: _vm.clearFile },
                  },
                  [_c("i", { staticClass: "fas fa-times-circle" })]
                ),
              ])
            : _c("file-input", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ clickHandler }) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "btn btn-link btn-link-purple px-0",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return clickHandler.apply(null, arguments)
                              },
                            },
                          },
                          [_c("i", { staticClass: "fas fa-folder-open" })]
                        ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.form.file,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "file", $$v)
                  },
                  expression: "form.file",
                },
              }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-form-item", [
        _c(
          "button",
          {
            staticClass: "btn btn-purple",
            attrs: { disabled: !_vm.isFileSelected },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.store.apply(null, arguments)
              },
            },
          },
          [_vm._v("Process")]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }